module.exports = {
  constrain: require('./constrain'),
  map: require('./map'),
  map_constrain: require('./map_constrain'),
  round_dec: require('./round_dec')
};



// WEBPACK FOOTER //
// ./node_modules/@zaibot/mathlib/src/index.js